import React from 'react'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'
import {SideShadow} from 'components/Accommodation/AccommodationView/Mobile/styles'
import {
  ReviewsTrackClick,
  SelectedElementType
} from 'components/Accommodation/ReviewsSection/ReviewsTrackClick'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {HorizontalScroll} from '@vio/atlas/helpers/HorizontalScroll'
import {Entity} from '@vio/core/src/analytics/types/Events'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'
import {ReviewRating} from '@vio/shared/src/search/ReviewRating'
import {ReviewSentiments} from '@vio/shared/src/search/ReviewSentiments'
import {Swiper} from '@vio/shared/src/search/Swiper'

import {ReviewSummaryLoading} from './ReviewSummaryLoading'
import {
  APFoldReviewRatingButton,
  ReviewRatingButton,
  ReviewRatingWrapper,
  ReviewSummaryWrapper,
  SentimentTagsWrapper,
  Wrapper
} from './styles'

interface Props {
  hotel?: ContentHotel
  onReviewSummaryClick: () => void
}

export const ReviewSummary: React.FC<Props> = ({
  onReviewSummaryClick,
  hotel
}) => {
  const {isMobile} = useDeviceLayout()
  const toggle = useToggle()
  const reviewRating = hotel?.guestRating?.overall

  // Show review summary loading
  if (!hotel) return <ReviewSummaryLoading />

  // Hide this section when we don't have review rating
  if (!reviewRating) return null

  if (isMobile) {
    return toggle(
      '90ef358d-ap-first-fold-improvement-v2',
      <ReviewSummaryWrapper>
        <ReviewRatingButton onClick={onReviewSummaryClick}>
          <SentimentTagsWrapper>
            <HorizontalScroll columnGap="s300">
              <ReviewRatingWrapper>
                <ReviewRating
                  underlineSubLabel
                  rating={reviewRating}
                  totalRatingCount={hotel.reviewCount}
                  dataId="ReviewRatingSummary"
                  hotelId={hotel.objectID}
                />
              </ReviewRatingWrapper>
              {hotel.sentiments?.length > 0 && (
                <ReviewsTrackClick
                  dataId="sentiments-subsection"
                  element={SelectedElementType.Sentiment}
                  entity={Entity.HotelDetailsReviewSummary}
                >
                  <ReviewSentiments
                    sentiments={hotel.sentiments}
                    hasResetTagSpacing={false}
                  />
                </ReviewsTrackClick>
              )}
            </HorizontalScroll>
          </SentimentTagsWrapper>
          <SideShadow side="end" />
        </ReviewRatingButton>
      </ReviewSummaryWrapper>,
      <APFoldReviewRatingButton onClick={onReviewSummaryClick}>
        <ReviewRating
          variant="squared"
          rating={reviewRating}
          totalRatingCount={hotel.reviewCount}
          dataId="ReviewRatingSummary"
          hotelId={hotel.objectID}
        />
      </APFoldReviewRatingButton>
    )
  }

  return (
    <div style={{overflow: 'hidden', width: '100%'}}>
      <Swiper gap="s300" right={0} left={0} shadowWidth={60}>
        <Wrapper>
          <ReviewRatingWrapper>
            <ReviewRatingButton onClick={onReviewSummaryClick}>
              <ReviewRating
                underlineSubLabel
                rating={reviewRating}
                totalRatingCount={hotel.reviewCount}
                dataId="ReviewRatingSummary"
                hotelId={hotel.objectID}
              />
            </ReviewRatingButton>
          </ReviewRatingWrapper>
          {hotel.sentiments?.length > 0 && (
            <ReviewsTrackClick
              dataId="sentiments-subsection"
              element={SelectedElementType.Sentiment}
              entity={Entity.HotelDetailsReviewSummary}
            >
              <ReviewSentiments
                sentiments={hotel.sentiments}
                hasResetTagSpacing={false}
                variant="slider"
              />
            </ReviewsTrackClick>
          )}
        </Wrapper>
      </Swiper>
    </div>
  )
}
